import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { MatchStatus } from '../types';
import type { StatusTone } from '../components/design-system/feedback/StatusBadge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Match-status → StatusBadge tone, preserving the sidebar StatusDot colours
 *  (accepted/completed→success, proposed→violet, else gold). The DS TONE_MAP
 *  maps `completed` to neutral, so pass this explicitly where the dot colours
 *  must stay as they were. */
export function matchStatusTone(status: MatchStatus): StatusTone {
  if (status === 'accepted' || status === 'completed') return 'success';
  if (status === 'proposed') return 'violet';
  return 'gold';
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/**
 * Unwraps a PostgREST embed that's meant to be at most one row. Whether
 * Supabase returns it as `T[]` or a bare `T` depends on whether it's
 * inferred the relationship as to-many or to-one (a `unique` constraint on
 * the FK column — like itineraries.match_id — flips it to a single object),
 * and that inference can change server-side independent of any app code.
 * Callers that hardcoded `rows?.[0]` silently treated a real, single
 * embedded row as "nothing embedded" the moment PostgREST switched shapes.
 */
export function embedOne<T>(value: T | T[] | null | undefined): T | null {
  if (value == null) return null;
  return Array.isArray(value) ? (value[0] ?? null) : value;
}
